(() => {
  function pushToDatalayer(items) {
    /* Push to dataLayer */
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'remove_from_cart',
      ecommerce: {
        items,
      },
    });

    console.log('%cEvent: remove_from_cart', 'color: #FF9100');
    console.log(window.dataLayer);
  }

  function handleCartUpdate(event) {
    const { newQuantity, productData } = event.detail;
    const quantityUpdated = newQuantity - (productData.quantity || 0);
    if (quantityUpdated >= 0) return;

    const items = [{...productData, ...{ quantity: (quantityUpdated * -1) }}];
    pushToDatalayer(items);
  }

  document.addEventListener('productQuantityChange', handleCartUpdate)
})();

